const menu = () => {
  var menuItemsWithSubmenu = [
    ...document.querySelectorAll(".primary-menu .menu-item-has-children"),
  ];

  menuItemsWithSubmenu.forEach((item) => {
    if (item.classList.contains("wpml-ls-item")) return;
    item.querySelector(".menu-item a").insertAdjacentHTML(
      "beforeend",
      `
            <div class="sub-menu__expanding | js-sub-menu-expanding" data-open='closed'>
            <div>
            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="9" y="3.6" width="1.8" height="9" rx="0.9" transform="rotate(90 9 3.6)" fill="white"/>
            <rect x="5.40039" y="9" width="1.8" height="9" rx="0.9" transform="rotate(-180 5.40039 9)" fill="white"/>
            </svg>
            
            </div>
            </div>
            `
    );
  });
  const expandingBtns = [
    ...document.querySelectorAll(".js-sub-menu-expanding"),
  ];
  expandingBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      console.log(btn.classList.contains("active"));
      if (btn.classList.contains("active")) {
        btn.parentElement.parentElement.classList.remove("active");
        btn.classList.remove("active");
      } else {
        btn.parentElement.parentElement.classList.add("active");
        btn.classList.add("active");
      }
    });
  });

  var hamburger = document.querySelector(".js-hamburger");
  var nav = document.querySelector(".js-navigation");
  var header = document.querySelector(".js-header");
  hamburger.addEventListener("click", () => {
    if (hamburger.getAttribute("data-open") === "closed") {
      hamburger.classList.add("header__hamburger--opened");
      nav.classList.add("header__nav--opened");
      header.classList.add("opened");
      hamburger.setAttribute("data-open", "opened");
    } else {
      hamburger.classList.remove("header__hamburger--opened");
      nav.classList.remove("header__nav--opened");
      header.classList.remove("opened");
      hamburger.setAttribute("data-open", "closed");
    }
  });
};

export default menu;
